module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n         Content Analysis\n        ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.igPost)
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                  NLU (Natural Language Understanding) Result\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("\n                  Concepts\n                ")]), _vm._v(" "), (_vm.concepts.length <= 0) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n                  No Data\n                ")]) : _vm._e(), _vm._v(" "), _c('p', _vm._l((_vm.concepts), function(content) {
    return _c('v-chip', {
      key: content.id
    }, [_vm._v(_vm._s(content.text))])
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("\n                  Sentiment\n                ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-capitalize",
    attrs: {
      "id": "nlu_sentiment_label"
    }
  }, [_vm._v("Positive")]), _vm._v(" score of\n                 "), _c('span', {
    style: (_vm.sentimentScoreCss),
    attrs: {
      "id": "nlu_sentiment_score"
    }
  }, [_vm._v(_vm._s(_vm.sentiment))])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                  Image Recognition Result\n                ")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "items": _vm.imageProcessingPagging.items,
      "fields": _vm.imageProcessingFields
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.imageProcessingPagging.totalRows,
      "per-page": _vm.imageProcessingPagging.perPage,
      "size": "sm",
      "align": "center"
    },
    model: {
      value: (_vm.imageProcessingPagging.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.imageProcessingPagging, "currentPage", $$v)
      },
      expression: "imageProcessingPagging.currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c163458"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ContentAnalysis/ContentAnalysisResultModal.vue
// module id = 2177
// module chunks = 0